import styled from "styled-components";
import dayjs from "dayjs";
import Typography from "./Typography";
import { Colors } from "../../config";

const Container = styled.div`
  width: 80%;
  border: 1px solid lightgrey;
  border-radius: 16px;
  display: flex;
  overflow: hidden;
  margin-top: 1rem;
`;

const ImageContainer = styled.div`
  width: 40%;
  @media only screen and (max-width: 986px) {
    display: none;
  }
`;

const BackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const InfoSection = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 0.5rem;
  @media only screen and (max-width: 986px) {
    width: 100%;
    display: flex;
    gap: 1rem;
    flex-direction: column;
  }
`;

const SectionHeader = styled.div`
  text-align: left;
  margin-bottom: 1rem;
  @media only screen and (max-width: 768px) {
    display: flex;
    gap: 0;
    flex-direction: column;
  }
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  & > :first-child {
    text-align: left;
  }

  & > :last-child {
    text-align: right;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    gap: 0;
    flex-direction: column;
    & > :first-child {
      text-align: center;
    }

    & > :last-child {
      text-align: center;
    }
  }
`;

function formatRoutes(routes) {
  return routes.map((route) => `${route.from} to ${route.to}`).join(", ");
}

const TravelCard = ({ bizSuccessImg, bookingId, leaveDetails, bizData }) => {
  return (
    <Container>
      <ImageContainer>
        <BackgroundImage src={bizSuccessImg} />
      </ImageContainer>

      <InfoSection>
        <SectionHeader>
          <Typography
            fontSize="16px"
            fontWeight={600}
            fontColor={Colors.prussianBlue}
          >
            Request ID : {bookingId}
          </Typography>
        </SectionHeader>

        <InfoRow>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.gray}>
            Leave Start Date
          </Typography>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.black}>
            {dayjs(leaveDetails?.startDate).format("MMM DD YYYY")}
          </Typography>
        </InfoRow>

        <InfoRow>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.gray}>
            Expected Return Date
          </Typography>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.black}>
            {dayjs(leaveDetails?.endDate).format("MMM DD YYYY")}
          </Typography>
        </InfoRow>

        <InfoRow>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.gray}>
            Travel Date
          </Typography>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.black}>
            {dayjs(bizData[0]?.departureDate).format("MMM DD YYYY")}
          </Typography>
        </InfoRow>

        <InfoRow>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.gray}>
            Travel Type
          </Typography>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.black}>
            {bizData?.length > 1 ? "Multi City" : bizData[0]?.type}
          </Typography>
        </InfoRow>

        <InfoRow>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.gray}>
            From/To
          </Typography>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.black}>
            {formatRoutes(bizData)}
          </Typography>
        </InfoRow>

        <InfoRow>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.gray}>
            Return Date
          </Typography>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.black}>
            {bizData?.length > 1
              ? "NA"
              : bizData[0]?.type?.replaceAll(" ", "").toLowerCase() !== "oneway"
              ? bizData[bizData?.length - 1]?.returnDate
                ? dayjs(bizData[bizData?.length - 1]?.returnDate).format(
                    "MMM DD YYYY"
                  )
                : "NA"
              : "NA"}
          </Typography>
        </InfoRow>

        <InfoRow>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.gray}>
            Services Selected
          </Typography>
          <Typography fontSize="14px" fontWeight={500} fontColor={Colors.black}>
            {bizData[0]?.businessRequirement
              ?.filter((br) => br.isChecked)
              .map((br) => br.name)
              .join(", ")}
          </Typography>
        </InfoRow>
      </InfoSection>
    </Container>
  );
};

export default TravelCard;
